import { useEffect, useState } from 'react';
import { getLangConfig, L } from '@lang';
import { getDocumentLang, hideSplashscreen, showSplashscreen, VkTranslationsLangCode } from './helpers';
import langFileConfig from './vkui-lang-config.json';

import { ErrorPage } from './pages/ErrorPage';
import { type LangLoadState, envs, AppContextProvider } from './core';
import { PwaInstallController } from './pages/PwaInstallController';

const langConfig = getLangConfig({
  config: langFileConfig,
  inputLang: VkTranslationsLangCode[getDocumentLang()],
  defaultLang: 'en',
  aliases: {
    uk: 'ru',
    ua: 'ru',
    kk: 'kz',
  },
});

export function App() {
  const [appLoadState, setAppLoadState] = useState<LangLoadState>('loading');

  const fetchLang = () => {
    setAppLoadState('loading');
    return L.init({
      forceFallback: false,
      vkMainUrl: `https://${envs.VK_HOST_DESKTOP}`,
      project: 'vk',
      config: langConfig,
      langFallback: () => Promise.resolve({}),
    })
      .then(() => setAppLoadState('success'))
      .catch(() => setAppLoadState('error'));
  };

  useEffect(() => {
    fetchLang();
  }, []);

  const isAppLoadStateLoading = appLoadState === 'loading';

  useEffect(() => {
    if (isAppLoadStateLoading) {
      showSplashscreen();
    } else {
      hideSplashscreen();
    }
  }, [isAppLoadStateLoading]);

  if (appLoadState === 'loading') {
    // Показывается нативный сплеш-скрин с помощью эффекта выше
    return <></>;
  }

  if (appLoadState === 'error') {
    return <ErrorPage onRetry={fetchLang} />;
  }

  return (
    <AppContextProvider>
      <PwaInstallController />
    </AppContextProvider>
  );
}
